<template>
  <div>
    <img v-if="isTyphoon" title="台风" class="typhoon-icon" src="../../assets/png/typ-blue.png" @click="changeTyphoon(false)"/>
    <img v-if="!isTyphoon" title="台风" class="typhoon-icon" src="../../assets/png/typ-gray.png" @click="changeTyphoon(true)"/>
  </div>
 
</template>

<script>
import { defineComponent } from 'vue'
import { Cartesian3, Color, PolylineDashMaterialProperty, Cartesian2, PolylineOutlineMaterialProperty, ScreenSpaceEventHandler, ScreenSpaceEventType, CallbackProperty, HorizontalOrigin, VerticalOrigin, PolygonHierarchy } from 'cesium'
import { getTyphoon } from '../../api/modules/meteo'
import { getTyphoonDeduce } from '../../api/modules/proxy'
import { getMeteoToken } from '../../utils/auth'
import store from '@/store/index'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default defineComponent({
  name: 'TyphoonBar',
  components: {},
  props: {
    viewer: {
      type: Object,
      default: () => { return null }
    },
    clientWidth: {
      type: Number,
      default: () => { return null }
    },
    clientHeight: {
      type: Number,
      default: () => { return null }
    },
    showIcons: {
      type: Boolean,
      default: () => { return null }
    }
  },
  data () {
    return {
      typhoonData: {},
      typhoonLineEntities: [],
      typhoonEyesEntities: [],
      curPoint: [],
      isTyphoon: true,
      timer: [],
      typhoonKey: '',
      handler: null
    }
  },
  mounted () {
    this.changeTyphoon(true)
    // this.timer = setInterval(() => {
    //    this.unpdateTyphoons()
    // }, 1 * 3600 * 1000) // 1小时更新一次台风数据
  },
  beforeDestroy () {
    // clearInterval(this.timer)
  },
  computed: {
    ...mapGetters(['timeGrid']),
    clientWidthScale () {
      return this.clientWidth / 1000
    }
  },
  watch: {
    showIcons: function(newValue) {
      if (!newValue) {
        this.changeTyphoon(false)
      }
    },
    timeGrid: function(newValue) {
      if (newValue) {
        const today = new Date()
        const today00 = new Date(today.setHours(0, 0, 0, 0))
        const date = moment(today00).add(newValue, 'h')
        const ts = date.unix() / 100
        
        // console.log(newValue,date)
        this.updateTyphoons(ts)
      }
    }
  },
  methods: {
    changeTyphoon (value) {
      this.isTyphoon = value
      this.removeTyphoonLineEntities()
      this.removeTyphoonEyesEntities()
      this.typhoonKey = ''
      if (this.isTyphoon) {
        // const ts = moment(new Date()).utc().unix() * 1000
        this.getTyphoonInfo()
      }
    },
    async getTyphoonInfo () {
      /**if (!getMeteoToken()) {
        await store.dispatch('GET_METEO_TOKEN')
      }**/
      // const params = {
      //   type: 'normal',
      //   timestamp: time
      // }
      getTyphoonDeduce().then((res) => {
        const data = res.data
        this.typhoonData = data
        this.addTyphoons(data)
      })
    },
    updateTyphoons (ts) {
      this.removeTyphoonEyesEntities()
      
      const typhoons = this.typhoonData || {}
      const keys = Object.keys(typhoons)

      keys.forEach(key => {
        const typhoonId = key
        const typhoon = typhoons[key] || {}
        const baseInfo = typhoon.baseInfo || {}
        const typhoonName = baseInfo.cName || baseInfo.eName
        const foreSets = typhoon.forecastSets && typhoon.forecastSets[0] ? typhoon.forecastSets[0] : {}
        const forePoints = foreSets.deduceRoute || []
        const curPoint = foreSets.currentPosition || {}

        let _diff = 0
        let _index = 0
        forePoints.forEach((item, index) => {
          const fts = item.time / 100000
          const diff = Math.abs(ts - fts)
          if (index === 0) {
            _diff = diff
            _index = 0
          } else {
            _index = diff < _diff ? index : _index
            _diff = diff < _diff ? diff : _diff
          }
        })
        const reducePoint = forePoints[_index]
        const namePoint = forePoints[_index]

        // 如果没有台风眼，则不添加任何东西
        if (curPoint && Object.keys(curPoint).length === 0) {
          return
        } else {
          this.addTyphoonIcon(reducePoint, typhoonId)
          this.addTyphoonName(namePoint, typhoonName)
        }
      })
    },
    addTyphoons (data) {
      this.removeTyphoonEyesEntities()
      this.destroyHandler()
      
      const typhoons = data || {}
      const keys = Object.keys(typhoons)

      keys.forEach(key => {
        const typhoonId = key
        const typhoon = typhoons[key] || {}
        const baseInfo = typhoon.baseInfo || {}
        const typhoonName = baseInfo.cName || baseInfo.eName
        const hisPoints = typhoon.historyPoint || []
        const foreSets = typhoon.forecastSets && typhoon.forecastSets[0] ? typhoon.forecastSets[0] : {}
        const forePoints = foreSets.forecastPoints || []
        hisPoints.push(forePoints[0])
        const curPoint = typhoon.currentPosition || foreSets.currentPosition || {}
        const namePoint = curPoint

        // 如果没有台风眼，则不添加任何东西
        if (curPoint && Object.keys(curPoint).length === 0) {
          return
        } else {
          this.addTyphoonIcon(curPoint, typhoonId)
          this.addTyphoonName(namePoint, typhoonName)
          // this.clickTyphoon()
          this.addTyphoonLines(key)
        }
      })
    },
    removeTyphoonEyesEntities() {
      this.typhoonEyesEntities.forEach((item) => {
        if (item) {
          this.viewer.removeEntity(item)
        }
      })
      this.typhoonEyesEntities = []
    },
    // @添加台风眼图标
    addTyphoonIcon (point, typhoonId) {
      if (point && Object.keys(point).length === 0) {
        return
      }
      // 台风眼小图标
      const windSpeed = point.maxSP || undefined
      let color = null
      let url = ''
        if (windSpeed <= 17.2) {
          color = Color.CHARTREUSE
          url = './png/typhoon7-2x.png'
        } else if (windSpeed > 17.2 && windSpeed <= 24.5) {
          color = Color.BLUE
          url = './png/typhoon7-2x.png'
        } else if (windSpeed > 24.5 && windSpeed <= 32.7) {
          color = Color.YELLOW
          url = './png/typhoon8-2x.png'
        } else if (windSpeed > 32.7 && windSpeed <= 41.5) {
          color = Color.ORANGE
          url = './png/typhoon9-2x.png'
        } else if (windSpeed > 41.5 && windSpeed <= 50.9) {
          color = Color.DEEPPINK
          url = './png/typhoon10-2x.png'
        } else if (windSpeed > 51.05) {
          color = Color.RED
          url = './png/typhoon11-2x.png'
        } else {
          color = Color.CHARTREUSE
          url = './png/typhoon7-2x.png'
      }

      // 10级风圈
      if (point.r10Ne > 0 || point.r10Nw > 0 || point.r10Sw > 0 || point.r10Se > 0) {
        const center = [point.lon, point.lat]
        const radiusData = {
          ne: point.r10Ne > 0 ? point.r10Ne : 0,
          nw: point.r10Nw > 0 ? point.r10Nw : 0,
          sw: point.r10Sw > 0 ? point.r10Sw : 0,
          se: point.r10Se > 0 ? point.r10Se : 0
        }
        const radiusCoords = this.getCircleCoords(center, radiusData)

        const typCircle10 = this.viewer.addEntity({
          polygon: {
            hierarchy: new PolygonHierarchy(
              Cartesian3.fromDegreesArray(radiusCoords)
            ),
            outline: true,
            outlineColor: new Color.fromBytes(255, 221, 95, 255),
            outlineWidth: 4,
            material: new Color.fromBytes(255, 221, 95, 50),
          }
        })

        this.typhoonEyesEntities.push(typCircle10)
      }

      // 7级风圈
      if (point.r7Ne > 0 || point.r7Nw > 0 || point.r7Sw > 0 || point.r7Se > 0) {
        const center = [point.lon, point.lat]
        const radiusData = {
          ne: point.r7Ne > 0 ? point.r7Ne : 0,
          nw: point.r7Nw > 0 ? point.r7Nw : 0,
          sw: point.r7Sw > 0 ? point.r7Sw : 0,
          se: point.r7Se > 0 ? point.r7Se : 0
          // ne: 60,
          // nw: 60,
          // sw: 0,
          // se: 60
        }
        const radiusCoords = this.getCircleCoords(center, radiusData)

        const typCircle7 = this.viewer.addEntity({
          polygon: {
            hierarchy: new PolygonHierarchy(
              Cartesian3.fromDegreesArray(radiusCoords)
            ),
            outline: true,
            outlineColor: new Color.fromBytes(255, 130, 0, 255),
            outlineWidth: 4,
            material: new Color.fromBytes(255, 130, 0, 100),
          }
        })

        this.typhoonEyesEntities.push(typCircle7)
      }

      // 台风眼小图标
      const scale = this.clientWidthScale / 2 // this.clientWidth <= 1921 ? 0.9 : 2.4
      let typEye = null
      // let cog = 360

      var rotation = 0

      function getRotationValue() {
        rotation -= 0.05;
        return rotation;
      }

      typEye = this.viewer.addEntity({ 
          id: typhoonId,
          name: 'typhoon',
          position: Cartesian3.fromDegrees(Number(point.lon), Number(point.lat), 0),
          billboard: {
            image: url,
            scale: scale,
            rotation: new CallbackProperty(getRotationValue, false),
            stRotation: new CallbackProperty(getRotationValue, false)
          }
        })

      this.typhoonEyesEntities.push(typEye)
    },
    getCircleCoords (center, radiusData) {
      const coords = []
      const p = 6
      const n = 360 / (p * 4) // 15
      const R = 6378245 // 地球半径
      const L = 2 * 3.14 * R
      const quadrant = {
        '0': 'ne',
        '1': 'nw',
        '2': 'sw',
        '3': 'se'
      }
      for (let i = 0; i < 4; i++) {
        let r = parseFloat(radiusData[quadrant[i]]) * 1000 || 0
        for (let j = i * n; j <= (i + 1) * n; j++) {
          const d = p * j === 360 ? 0 : p * j
          const x = center[0] + r * Math.cos(d * Math.PI / 180) * 180 / L
          const y = center[1] + r * Math.sin(d * Math.PI / 180) * 180 / L
          const coord = [x, y]
          coords.push(...coord)
        }
      }

      return coords
    },
    // @添加台风名称
    addTyphoonName (point, name) {
      const scale = this.clientWidthScale / 6
      const xOffset = this.clientWidthScale * 20 // this.clientWidth <= 1921 ? 40 : 100
      const padding = this.clientWidthScale * 10

      const typName = this.viewer.addEntity({
        position: Cartesian3.fromDegrees(Number(point.lon), Number(point.lat), 0),
        label: {
          text: name,
          show: true,
          font: '44px sans-serif',
          scale: scale,
          fillColor: Color.WHITE,
          showBackground: true,
          backgroundPadding: new Cartesian2(padding, padding),
          pixelOffset: new Cartesian2(xOffset, 0)
        }
      })
      this.typhoonEyesEntities.push(typName)
    },
    // @添加台风信息
    addTyphoonTips (key) {
      const data = this.typhoonData[key]
      const foreSets = data.forecastSets && data.forecastSets[0] ? data.forecastSets[0] : {}
      const curPoint = foreSets.currentPosition || {}
      const baseInfo = data.baseInfo
      const name = data.baseInfo.cName || data.baseInfo.eName || ''

      const typTips = this.viewer.addEntity({
        position: Cartesian3.fromDegrees(Number(curPoint.lon), Number(curPoint.lat), 0),
        label: {
          text: '名称：' + name + '\n'
           + '编号：' + baseInfo.stormID + '\n'
           + '最大风速：' + curPoint.maxSP + '\n'
           + '最小风速：' + curPoint.minP + '\n',
          show: true,
          font: '24px sans-serif',
          scale: 0.5,
          fillColor: Color.WHITE,
          pixelOffset: new Cartesian2(0, -20),
          horizontalOrigin: HorizontalOrigin.LEFT,
          verticalOrigin: VerticalOrigin.BOTTOM
        }
      })
      this.typhoonEyesEntities.push(typTips)
    },
    flyToTyphoonEye (point) {
      this.viewer.flyTo(point)
    },
    // 添加台风线函数
    addLine (pointsData, type) {
      const width = this.clientWidthScale / 2
      const outlineWidth = this.clientWidthScale / 2
      const dashLength = this.clientWidthScale * 3
      const pixelSize = this.clientWidthScale * 4
      
      if (pointsData && pointsData.length === 0) {
        return
      }

      let data = pointsData
      if (type === 'history') {
        if (pointsData && pointsData.length >= 30) {
          const l = Math.floor(pointsData.length / 30)
          data = pointsData.filter((item, i) => {
            return i % l === 0 
          }) 
        }
      }

      const linePoints = []
      data.forEach(item => {
        if(!item) {
          return
        }
        const point = [Number(item.lon), Number(item.lat), 0]
        linePoints.push(...point)
        // const strongLevel = item.strong || ''
        const windSpeed = item.maxSP || undefined
        let color = null
        let url = ''
        if (windSpeed <= 17.2) {
          color = Color.CHARTREUSE
          url = './png/typhoon7.png'
        } else if (windSpeed > 17.2 && windSpeed <= 24.5) {
          color = Color.BLUE
          url = './png/typhoon7.png'
        } else if (windSpeed > 24.5 && windSpeed <= 32.7) {
          color = Color.YELLOW
          url = './png/typhoon8.png'
        } else if (windSpeed > 32.7 && windSpeed <= 41.5) {
          color = Color.ORANGE
          url = './png/typhoon9.png'
        } else if (windSpeed > 41.5 && windSpeed <= 50.9) {
          color = Color.DEEPPINK
          url = './png/typhoon10.png'
        } else if (windSpeed > 51.05) {
          color = Color.RED
          url = './png/typhoon11.png'
        } else {
          color = Color.CHARTREUSE
          url = './png/typhoon6.png'
        }

        const dotEntity = this.viewer.addEntity({
          position: Cartesian3.fromDegrees(Number(item.lon), Number(item.lat), 0),
          point: {
            show: true, // default
            color: color, // default: WHITE
            pixelSize: pixelSize, // default: 1
            outlineColor: Color.BLACK, // default: BLACK
            // clampToGround: true,
            outlineWidth: outlineWidth // default: 0，
          },
        })

        this.typhoonLineEntities.push(dotEntity)
      })

      let lineEntity = null
      if (type === 'history') {
        lineEntity = this.viewer.addEntity({
          polyline: {
            positions: Cartesian3.fromDegreesArrayHeights(linePoints),
            width: width,
            // material: Color.BLACK,
            material: new PolylineOutlineMaterialProperty({
              color: Color.BLACK,
              outlineColor: Color.BLACK,
              outlineWidth: outlineWidth
            }),
            clampToGround: true,
            zIndex: 5
          }
        })
      } else {
        lineEntity = this.viewer.addEntity({
          polyline: {
            positions: Cartesian3.fromDegreesArrayHeights(linePoints),
            width: width,
            material: new PolylineDashMaterialProperty({
              color: Color.BLACK,
              dashLength: dashLength
            }),
            clampToGround: true,
            zIndex: 5
          }
        })
      }

      this.typhoonLineEntities.push(lineEntity)
    },
    addTyphoonLines (key) {
      const data = this.typhoonData[key]
      const hisPoints = data.historyPoint || []
      const foreSets = data.forecastSets && data.forecastSets[0] ? data.forecastSets[0] : {}
      console.log('typhoon', foreSets)
      const forePoints = foreSets.deduceRoute || []
      const curPoint = foreSets.currentPosition || {}
      if (hisPoints && hisPoints.length > 0) {
        hisPoints.push(forePoints[0])
      }
      this.addLine(hisPoints, 'history')
      this.addLine(forePoints, 'forecast')
      // this.flyToTyphoonEye(curPoint)
    },
    removeTyphoonLineEntities() {
      this.typhoonLineEntities.forEach((item) => {
        if (item) {
          this.viewer.removeEntity(item)
        }
      })
      this.typhoonLineEntities = []
    },
    // clickTyphoon () {
    //   this.handler = new ScreenSpaceEventHandler(this.viewer.scene.canvas)
    //   this.handler.setInputAction((click) => {
    //     const pick = this.viewer.scene.pick(click.position)
    //     if (pick && pick.id) {
    //       if (pick.id._name === 'typhoon') {
    //         this.removeTyphoonLineEntities()
    //         const key = pick.id._id
    //         this.typhoonKey = key
    //         this.addTyphoonLines(key)
    //         // this.addTyphoonTips(key)
    //       }
    //     }
    //   }, ScreenSpaceEventType.LEFT_CLICK)
    // },
    destroyHandler () {
      if (this.handler) {
        this.handler.destroy()
      }
    }
  }
})
</script>

<style lang="scss">
  @import '../../styles/variables';

  @media screen and (max-width: 1920px) {
    .typhoon-icon {
      height: $icon-height-1920;
      width: $icon-width-1920;
      cursor: pointer;
      box-sizing: border-box;
      margin: 5px 0;
      background: rgba(0,0,0,0.4);
      width: 32px;
    }
  }

  @media screen and (min-width: 1921px) {
    .typhoon-icon {
      height: $icon-height-2560;
      width: $icon-width-2560;
      cursor: pointer;
      box-sizing: border-box;
      background: rgba(0,0,0,0.4);
      margin: 10px 0;
    }
  }

  @media screen and (min-width: 2561px) {
    .typhoon-icon {
      height: $icon-height-4368;
      width: $icon-width-4368;
      cursor: pointer;
      box-sizing: border-box;
      margin: 15px 0;
    }
  }

  @media screen and (min-width: 6700px) {
    .typhoon-icon {
      height: $icon-height-6720;
      width: $icon-width-6720;
      cursor: pointer;
      box-sizing: border-box;
      margin: 20px 0;
    }
  }
  
</style>
